// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import {
  ActionSheetContext,
  ActionSheetV2,
  Body,
  Button,
  Description,
  InlineAlert,
  LgPadding,
  MdSpacing,
} from '@alto/design-system';
import React, { useContext } from 'react';
// eslint-disable-next-line import/no-deprecated
import { deselectPrescription, updatePrescription } from '~shared/actions/prescriptions';
import { AUTO_REFILL_OFF_ACTION_SHEET } from '~shared/features/auto-refill/constants';
import { getSelectedPrescription } from '~shared/features/prescriptions/selectors/getSelectedPrescription';
import { getErrorMessage } from '~shared/helpers/helper';
import { useDispatchShared, useSelectorShared } from '~shared/store';

export const AutoRefillActionSheet = () => {
  const dispatch = useDispatchShared();
  const { closeActionSheet } = useContext(ActionSheetContext);
  const loading = useSelectorShared((state) => state.ui.loading.updatePrescriptionLoading);
  const error = useSelectorShared((state) => state.ui.errors.updatePrescriptionError);
  const prescription = useSelectorShared(getSelectedPrescription);

  const handleClose = () => {
    dispatch(deselectPrescription());
    closeActionSheet();
  };

  const handleTurnOffAutoRefill = async () => {
    if (!prescription) return;
    const success = await dispatch(
      // eslint-disable-next-line import/no-deprecated
      updatePrescription({
        id: prescription?.id,
        auto_refill: false,
      }),
    );
    if (success) {
      handleClose();
    }
  };

  return (
    <ActionSheetV2
      title={AUTO_REFILL_OFF_ACTION_SHEET.title}
      analyticsName="auto-refill"
      buttons={[
        <Button
          key="auto-refill-off-button"
          label={AUTO_REFILL_OFF_ACTION_SHEET.button}
          loadingLabel="Updating auto-refill"
          loading={loading}
          onPress={handleTurnOffAutoRefill}
        />,
        <Button
          key="close-auto-refill-button"
          label="Cancel"
          onPress={handleClose}
          type="tertiary"
        />,
      ]}
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>{AUTO_REFILL_OFF_ACTION_SHEET.getBody()}</Body>
        {error ? (
          <>
            <MdSpacing />
            <InlineAlert type="error">
              <Description>{getErrorMessage(error)}</Description>
            </InlineAlert>
          </>
        ) : null}
      </LgPadding>
    </ActionSheetV2>
  );
};
